/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import Scrollbars from "react-custom-scrollbars";
import Headroom from "react-headroom";
import Header from "./header";
import Navbar from "./navbar";
import "./layout.css";

export default class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.renderHeader = this.renderHeader.bind(this);
  }

  renderHeader() {
    if (this.props.header) {
      return <Header forwardRef={(headerElement) => {
        console.log(headerElement);
      }} />;
    }
  }

  render() {
    return <StaticQuery
      query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
      render={data => (
        <>
          {this.renderHeader()}
          <Navbar main={this.props.header}
          // scrollThreshold={this.state.height}
          />
          <div
            style={{
              margin: `0 auto`,
              maxWidth: 960,
              padding: `1rem 1.0875rem 1.45rem`
            }}
          >
            <main>{
              this.props.children
                .map(child => <>
                  {child}
                  <hr />
                </>)
            }</main>
            <footer>
              © {new Date().getFullYear()} Daniel Roitenburd - <a href="#mailto:droiten@intramed.net">droiten@intramed.net</a>
            </footer>
          </div>
        </>
      )}
    />
  }
}
